import { useNavigate } from 'react-router-dom';
import '../style/countriesvisited.css';
import Footer from '../components/footer';

function CountriesVisited() {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    navigate('/');
  };

  // All countries visited with years and flags
  const countriesVisited = [
    // Recent years (2025-2015) from your previous lists
    { year: 2026, countries: [{ name: 'Svalbard', flag: '🇳🇴' }] },
{ year: 2025, countries: [{ name: 'Vietnam', flag: '🇻🇳' }, { name: 'Gibraltar', flag: '🇬🇮' }, { name: 'Switzerland', flag: '🇨🇭' }, { name: 'Norway', flag: '🇳🇴' }, { name: 'Bosnia and Herzegovina', flag: '🇧🇦' }] },
    { year: 2024, countries: [{ name: 'Uganda', flag: '🇺🇬' }, { name: 'Kyrgyzstan', flag: '🇰🇬' }] },
    { year: 2023, countries: [{ name: 'Israel', flag: '🇮🇱' }, { name: 'Luxembourg', flag: '🇱🇺' }, { name: 'Georgia', flag: '🇬🇪' }] },
    { year: 2022, countries: [{ name: 'Mexico', flag: '🇲🇽' }, { name: 'Albania', flag: '🇦🇱' }, { name: 'Ireland', flag: '🇮🇪' }, { name: 'Montenegro', flag: '🇲🇪' }] },
    { year: 2021, countries: [{ name: 'Bornholm (Denmark)', flag: '🇩🇰' }] },
    { year: 2020, countries: [{ name: 'Bali (Indonesia)', flag: '🇮🇩' }, { name: 'Croatia', flag: '🇭🇷' }] },
    { year: 2019, countries: [{ name: 'Jordan', flag: '🇯🇴' }, { name: 'Lithuania', flag: '🇱🇹' }, { name: 'Slovenia', flag: '🇸🇮' }] },
    { year: 2018, countries: [{ name: 'Costa Rica', flag: '🇨🇷' }, { name: 'Norway', flag: '🇳🇴' }] },
    { year: 2017, countries: [{ name: 'Sri Lanka', flag: '🇱🇰' }] },
    { year: 2016, countries: [{ name: 'Cape Verde', flag: '🇨🇻' }] },
    { year: 2015, countries: [{ name: 'Latvia', flag: '🇱🇻' }] },
    
    // Older years (2013-1992) from your new list
    { year: 2013, countries: [{ name: 'Madeira (Portugal)', flag: '🇵🇹' }, { name: 'Macedonia (North Macedonia)', flag: '🇲🇰' }] },
    { year: 2012, countries: [{ name: 'Morocco', flag: '🇲🇦' }] },
    { year: 2011, countries: [{ name: 'UAE', flag: '🇦🇪' }, { name: 'Oman', flag: '🇴🇲' }] },
    { year: 2010, countries: [{ name: 'Scotland', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿' }, { name: 'Zakynthos (Greece)', flag: '🇬🇷' }] },
    { year: 2009, countries: [{ name: 'Romania', flag: '🇷🇴' }, { name: 'Portugal', flag: '🇵🇹' }] },
    { year: 2008, countries: [{ name: 'Azores (Portugal)', flag: '🇵🇹' }, { name: 'Estonia', flag: '🇪🇪' }, { name: 'Finland', flag: '🇫🇮' }] },
    { year: 2007, countries: [{ name: 'Turkey', flag: '🇹🇷' }, { name: 'Hungary', flag: '🇭🇺' }] },
    { year: 2006, countries: [{ name: 'Poland', flag: '🇵🇱' }, { name: 'Iceland', flag: '🇮🇸' }, { name: 'Tanzania', flag: '🇹🇿' }] },
    { year: 2004, countries: [{ name: 'Bulgaria', flag: '🇧🇬' }, { name: 'Faroe Islands', flag: '🇫🇴' }, { name: 'Malta', flag: '🇲🇹' }] },
    { year: 2003, countries: [{ name: 'Greenland', flag: '🇬🇱' }, { name: 'Spain', flag: '🇪🇸' }, { name: 'China', flag: '🇨🇳' }] },
    { year: 2002, countries: [{ name: 'Cuba', flag: '🇨🇺' }, { name: 'France', flag: '🇫🇷' }] },
    { year: 2001, countries: [{ name: 'Cyprus', flag: '🇨🇾' }, { name: 'India', flag: '🇮🇳' }] },
    { year: 2000, countries: [{ name: 'Ecuador', flag: '🇪🇨' }] },
    { year: 1998, countries: [{ name: 'USA)', flag: '🇺🇸' }] },
    { year: 1997, countries: [{ name: 'Tunisia', flag: '🇹🇳' }] },
    { year: 1995, countries: [{ name: 'Sweden', flag: '🇸🇪' }, { name: 'Thailand', flag: '🇹🇭' }] },
    { year: 1992, countries: [{ name: 'Italy', flag: '🇮🇹' }] }
  ];

  return (
    <div className="countries-visited-page">
      <h1>Countries Visited</h1>
      <div className="countries-list">
        {countriesVisited.map((yearEntry) => (
          <div key={yearEntry.year} className="year-entry">
            <h2>{yearEntry.year}</h2>
            <ul>
              {yearEntry.countries.map((country, index) => (
                <li key={index}>
                  <span className="country-flag">{country.flag}</span>
                  <span className="country-name">{country.name}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default CountriesVisited;